import AxiosAdminAPI from "../../../../util/AxiosAdminAPI";
import EnterpriseComponent from "../../EnterpriseComponent";
import {V1WorkGroupOrganizationIDOCToArray} from "../../../../util/Payload";
import {v4 as uuidv4} from "uuid";

class WorkGroupOrganizationEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let idocResponse = this.getIDOCResponse() ?? "v1.WorkGroup-002";

        let qbe = btoa(JSON.stringify({
            "PlatformMessage": {
                "-idoc": idocResponse,
                "-id": uuidv4(),
                "WorkGroup": {
                    "_attributes": {
                        "limit": 1,
                        "sort": null,
                        "offset": 0
                    },
                    "QueryGroups": {
                        "QueryGroup": [
                            {
                                "Name": "QG1",
                                "Type": "QueryGroup",
                                "Operator": "AND",
                                "Membership": {
                                    "Member": [
                                        {
                                            "Type": "Attribute",
                                            "Name": "USID",
                                            "Value": foreignKey,
                                            "Operator": "EQUAL"
                                        }
                                    ]
                                }
                            }
                        ]
                    },
                    "Organization": {
                        "_attributes": {
                            "limit": pageSize,
                            "sort": this.getFormattedSortSpecification(),
                            "offset": (page - 1) * pageSize
                        }
                    }
                }
            }
        }))

        AxiosAdminAPI({
            method: "GET",
            url: "t6/v1/work_groups",
            json: true,
            params: {
                "QBE": qbe
            },
            headers: {
                "idoc-response": idocResponse,
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1WorkGroupOrganizationIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

    enterpriseComponentPostIDOC = () => {
        let payload = {};

        let WorkGroup = {};

        WorkGroup["USID"] = this.getEnterpriseObject().getEnterpriseComponent("WorkGroup").getAttributeValue("USID");
        WorkGroup["Organization"] = {
            "USID": this.getAttributeValue("USID")
        }

        payload.PlatformMessage = {};
        payload.PlatformMessage["-idoc"] = "v1.WorkGroup-002";
        payload.PlatformMessage.WorkGroup = WorkGroup;

        return payload;
    };

    performInsert() {
        let payload = this.enterpriseComponentPostIDOC();

        let options = {
            method: "PUT",
            url: "t6/v1/work_groups",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.WorkGroup-002",
                "idoc-response": "v1.WorkGroup-002"
            },
        };
        this.notifyInsertStartListeners();
        AxiosAdminAPI(options)
            .then(response => {
                this.insertEnterpriseComponentSuccess(V1WorkGroupOrganizationIDOCToArray(response.data));
            })
            .catch(error => {
                this.insertEnterpriseComponentFailed(error);
            });
    };

    performDelete() {
        let payload = {
            "PlatformMessage": {
                "-idoc": "v1.WorkGroup-002",
                "WorkGroup": {
                    "_attributes": {
                        "delete": false
                    },
                    "USID": this.getEnterpriseObject().getEnterpriseComponent("WorkGroup").getAttributeValue("USID"),
                    "Organization": {
                        "_attributes": {
                            "delete": true
                        },
                        "USID": this.getAttributeValue("USID")
                    }
                }
            }
        }

        let options = {
            method: "DELETE",
            url: "t6/v1/work_groups",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.WorkGroup-002"
            },
        };
        this.notifyDeleteStartListeners();
        AxiosAdminAPI(options)
            .then(() => {
                this.deleteEnterpriseComponentSuccess();
            })
            .catch(error => {
                this.deleteEnterpriseComponentFailed(error);
            });
    };
}

export default WorkGroupOrganizationEnterpriseComponent;